
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { reportEngagement } from "../../utilities/server-update-analytics";



const DEBUG = process.env.REACT_APP_DEBUG === "true";



function PageViewTracker() {

    const location = useLocation();

    const entryTimeRef = useRef(Date.now());


    useEffect(() => {
        const path = location.pathname + location.search;

        const entryTime = Date.now();
        entryTimeRef.current = entryTime;


        const handleBeforeUnmount = () => {
            const exitTime = Date.now();
            const timeSpentSeconds = (exitTime - entryTimeRef.current) / 1000; // Convert to seconds

            if( DEBUG && timeSpentSeconds < 1 ) {
                // TODO: Seems duplicate render causes analytics report to be made twice., one super short.. and other when Component actually unmounts ... ??? Uncertian this is the case, though
                return;
            }

            reportEngagement({
                engagementType: "pageView", //EngagementType.PAGE_VIEW, // TODO: Use once moved to Shared Library
                engagementDetails: {
                    path,
                    timeSpentSeconds,
                }
            });
        }

        return () => {
            handleBeforeUnmount();
        }
    }, [location]);

    return null; // This component does not render anything
}

export default PageViewTracker;

